import { Box, Text } from '@rsos/base-components';
import { useGetSelectedCollaborator } from '@rsos/reduxDataStore/src/features/emergencyCalls/helpers';
import { CollapseButton } from '../SharedChatUI/CollapseButton';
import { HeaderContainer, RedCircle } from './CollaboratorChatbox.styles';

const CollaboratorChatHeader = () => {
  const collaborator = useGetSelectedCollaborator();

  return (
    <HeaderContainer data-name="conversations-chat-header" pb="16px" pt="12px">
      <Box horizontal justify="space-between" px="12px" width="100%">
        <Box>
          <Text inline fontWeight="bold">
            <Text color="primaryText" size="normal">
              <RedCircle />
              Agency Live Chat
            </Text>
            <Box horizontal>
              <Text color="secondaryText" fontWeight="regular" size="xsmall">
                {collaborator.pairedAccountName}
              </Text>
            </Box>
          </Text>
        </Box>
        <CollapseButton />
      </Box>
    </HeaderContainer>
  );
};

export default CollaboratorChatHeader;
